import { I04CALCULGDETA_State } from '@batical/types/src'

const I04CALCULGDETA: I04CALCULGDETA_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_surface: 95.0,
  in_hspm: 0.0,
  ventilation_uuid: 'Ventil0',
  in_ventil_lambda: 0.0,
  res_volume: 0.0,
  res_coeffG: 0.0,
  in_nb_facade: 0,
  facades: [],
  in_nb_plafond: 0,
  plafonds: [],
  in_nb_plancher: 0,
  planchers: [],
  in_nb_vitrage: 0,
  vitrages: [],
  in_nb_porte: 0,
  portes: [],
  res_graph: [],
  mode: 'none',
  calcul_code: 'I04CALCULGDETA'
}

export default I04CALCULGDETA
